import React__default from 'react';
import { CartContext } from '../../context/CartContext.esm.js';
import '../../context/CartSettingsContext.esm.js';
import 'tslib';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../constants/api.esm.js';
import styles from './GeneItem.module.esm.js';

var GeneItem = function (_a) {
    var _b = _a.gene, code = _b.code, name = _b.name, _c = _a.shouldAllowGeneRemoval, shouldAllowGeneRemoval = _c === void 0 ? true : _c;
    var removeFromCart = React__default.useContext(CartContext).removeFromCart;
    var onRemoveGene = React__default.useCallback(function () {
        removeFromCart([code]);
    }, [code, removeFromCart]);
    return (React__default.createElement(React__default.Fragment, null, shouldAllowGeneRemoval ? (React__default.createElement("button", { className: styles.gene, "data-testid": "gene-item-".concat(code), onClick: onRemoveGene },
        React__default.createElement(React__default.Fragment, null,
            name,
            React__default.createElement("span", { className: styles.removeIcon }, "\u00D7")))) : (React__default.createElement("button", { className: styles.gene, "data-testid": "gene-item-".concat(code), disabled: true }, name))));
};

export { GeneItem as default };
//# sourceMappingURL=GeneItem.esm.js.map
